var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.testimonials)?_c('div',{staticClass:"grid grid-cols-1 lg:grid-cols-2 gap-6"},_vm._l((_vm.testimonials),function(testimonial){return _c('TestimonialCard',{key:testimonial.id,attrs:{"text":testimonial.text,"user":testimonial.user}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }